export const fileExtensionToFileTypeMap = {
  jpg: 'image/jpeg',
  pdf: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
};

export const fileTypeToFileExtensionMap = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'application/pdf': 'pdf',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
};

export const downloadFromUrl = (fileUrl: string, title?: string) => {
  const a = document.createElement('a');
  a.href = fileUrl;
  a.download = title || 'download';
  a.target = '_blank';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const formatFileSize = (sizeInBytes: number) => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];

  let size = sizeInBytes;
  let unitIndex = 0;

  while (size >= 1000 && unitIndex < units.length - 1) {
    size /= 1000;
    unitIndex++;
  }

  if (unitIndex === 0) {
    // Bytes → no decimals
    return `${size} ${units[unitIndex]}`;
  } else if (unitIndex === 1) {
    // KB → whole numbers
    return `${Math.round(size)} ${units[unitIndex]}`;
  } else {
    // MB and above → 1 decimal place
    return `${size.toFixed(1)} ${units[unitIndex]}`;
  }
};
